import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import "./CustomDashboardCard.css";
import { themes, fonts } from "../../themes/themes";

import "../../themes/i18n";
interface ICustomDashboardCardProps {
  cardSize: {
    card_title?: string;
  };
  isCalendar?: boolean;
  color?: string;
}

const CustomDashboardCard: React.FC<
  React.PropsWithChildren<ICustomDashboardCardProps>
> = ({
  children,
  cardSize,
  isCalendar = false,
  color = themes.blackDefault,
}) => {

  return (
    <Box
      className={
        isCalendar ? "dashboard_calendar_card" : "custom-dashboard-Card"
      }
    >
      <Grid container>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <Grid
            item
            xs={6}
            style={{
              justifyContent: "right",
            }}
          >
            <Typography
              style={{
                color: color,
                fontSize: fonts.header,
                fontFamily: fonts.fontFamily,
                fontWeight: "bold",
              }}
            >
              {cardSize.card_title}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Box
        className={
          isCalendar ? "calendar__card__hover__styling" : "card__hover__styling"
        }
      >
        {children}
      </Box>
    </Box>
  );
};

export default CustomDashboardCard;
